import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import styles from './styles';

const WccChat = ({ openchat }) => {
  const classes = styles();

  useEffect(() => {
    let chatPopOutObject = null;
    window.addEventListener('message', function (e) {
      console.log('inside live meet chart', e);
      let customChatStyleString = '';
      let chatObj = document.querySelector('.playerchatContent iframe');
      chatObj = chatObj.contentWindow;
      if (chatPopOutObject != null) {
        chatObj = chatPopOutObject;
      }
      const jsonParse = JSON.parse(e.data);
      if (jsonParse.action == 'getuserdata') {
        //Call received from chat and send to ppv
        if (window.opener == null) {
          window.parent.postMessage(
            JSON.stringify({ action: 'getuserdata', from: 'livemeet' }),
            '*'
          );
        } else {
          window.opener.postMessage(
            JSON.stringify({ action: 'getuserdata', from: 'livemeet' }),
            '*'
          );
        }
      } else if (jsonParse.action == 'getchatstyle') {
        //Call received from chat and send to ppv
        if (window.opener == null) {
          window.parent.postMessage(
            JSON.stringify({ action: 'chatstyleresponse', from: 'livemeet' }),
            '*'
          );
        } else {
          window.opener.postMessage(
            JSON.stringify({ action: 'chatstyleresponse', from: 'livemeet' }),
            '*'
          );
        }

        const dataString =
          '{"messageListPage":[{"key":"--msg-l-color","value":"","id":"chatMessageLeftColor"},{"key":"--chat-box-bg","value":"","id":"chatBodyColor"}],"customStyleString":""}';
        const data = JSON.parse(dataString);
        customChatStyleString = data.customStyleString;
        ((styleText) => {
          setTimeout(() => {
            chatObj.postMessage(
              JSON.stringify({ action: 'setcustomcss', body: styleText }),
              '*'
            );
          }, 100);
        })(data.customStyleString);
        const styleArray = data.messageListPage;
        for (const i of styleArray) {
          ((key, color) => {
            setTimeout(() => {
              chatObj.postMessage(
                JSON.stringify({ action: 'setcolor', text: key, value: color }),
                '*'
              );
            }, 100);
          })(i.key, i.value);
        }
      } else if (jsonParse.action == 'pop-out-chat') {
        $(`[src="${process.env.REACT_APP_CHAT_URL}"]`).attr(
          'id',
          'newChatframe'
        );
        const urlStr = $('#newChatframe').attr('src');

        const url = new URL(urlStr);
        url.searchParams.delete('displaypopout');
        url.searchParams.append('displaypopout', false);
        chatPopOutObject = window.open(
          url.href,
          '_blank',
          'width=350px,height=500px'
        );
        let getSubActiveRightPanelId = null;
        const playerActiveRightPanel = $('.vjs-right-panel.active');
        if (
          playerActiveRightPanel != undefined &&
          playerActiveRightPanel != null &&
          playerActiveRightPanel['length']
        ) {
          getSubActiveRightPanelId = playerActiveRightPanel[0].getAttribute(
            'data-right-panel-button'
          );
          if (
            getSubActiveRightPanelId != undefined &&
            getSubActiveRightPanelId != null
          ) {
            $('#right-panel-button-' + getSubActiveRightPanelId).click();
          }
        }

        const funCheckWindow = () => {
          if (chatPopOutObject != null && !chatPopOutObject.closed) {
            this.setTimeout(funCheckWindow, 500);
          } else if (chatPopOutObject != null && chatPopOutObject.closed) {
            $('#newChatframe').attr('src', `${process.env.REACT_APP_CHAT_URL}`);

            //Load chat again if not opened any other side panels.
            const playerActiveRightPanel2 = $('.vjs-right-panel.active');
            if (playerActiveRightPanel2['length'] == 0) {
              $('#right-panel-button-' + getSubActiveRightPanelId).click();
            }

            chatPopOutObject = null;
          }
        };
        $('#newChatframe').attr('src', '');
        funCheckWindow();
      } else if (jsonParse.action == 'getpollconfig') {
        //From live meet to ppv
        if (window.opener == null) {
          window.parent.postMessage(
            JSON.stringify({
              action: 'getpollconfig',
              from: 'livemeet',
            }),
            '*'
          );
        } else {
          window.opener.postMessage(
            JSON.stringify({
              action: 'getpollconfig',
              from: 'livemeet',
            }),
            '*'
          );
        }
      }
    });
  }, []);

  return (
    <>
      <div
        className={`${openchat ? '' : classes.hidden} relative ${
          classes.chatMain
        }`}
      >
        {/* <div className="modal-content h-full poll-popup-max live-studio-border">
                <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md mt-4">
                <i className="fa fa-2x fas fa-comment live-studio-heading"></i>
                <h5
                className="text-xl font-semibold leading-normal text-center w-full live-studio-heading"
                id="PollModalLabel">
                Chat
                </h5>
                <i className="fas fa-external-link-alt live-studio-heading"></i>
                </div>
                </div> */}
        <div className={`playerchatContent ${classes.chatWrap}`}>
          <iframe
            title='chat-iframe'
            className='chat-iframe'
            id='chatFrame'
            src={process.env.REACT_APP_CHAT_URL}
            width='100%'
            height='100%'
            allow='autoplay'
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default WccChat;
